import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import StarPurple500SharpIcon from '@mui/icons-material/StarPurple500Sharp';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { setDefaultStore } from '../CartDrawer/utils';
import {
  activeMenu,
  allactiveMenues,
  checkStore,
  menues,
  setUser,
} from '../../../../../../libs/redux-slices/src';
import { firestore } from '../../../../../../libs/firebase-service/src';
import { environment } from '../../../environments/environment';
import { useTranslation } from 'react-i18next';

const CARD_WIDTH = 280;
const CARD_HEIGHT = 360;
const IMAGE_HEIGHT = 160;

export default function RestaurantHomeCard({ store }) {
  const token = useSelector((state) => state.authReducer.token);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.authReducer.userData);
  const cart = useSelector((state) => state.shopReducer.cart);
  const items = useSelector((state) => state.shopReducer.currentItem);
  const navigate = useNavigate();
  const [t] = useTranslation();

  const displayName =
    store.businessName.length > 15
      ? `${store.businessName.substring(0, 15)}...`
      : store.businessName;

  const handleClick = async () => {
    setDefaultStore(
      token,
      store.id,
      store.businessName,
      store.pickup_enabled,
      store.pickup_enabled,
      store.dinein_enable,
      store.dinein_enable,
      store.address.displayName,
      store.address.displayName
    );
    dispatch(checkStore(!!(userData?.bagItems?.length && cart?.length)));
    const updatedUser = { ...userData, defaultStore: store.id };
    dispatch(setUser({ userData: updatedUser }));
    dispatch(activeMenu(store.active_menu_now));

    const snapshot = await firestore
      .collection('menus')
      .where('store_id', '==', store.id)
      .get();
    const menusData = snapshot.docs.map((doc) => doc.data());

    let popularItems = [];
    if (menusData.length) {
      menusData.forEach((menu) => {
        menu.category_id.forEach((cat) => {
          cat.items_id.forEach((id) => {
            const itm = items.find((item) => item.id === id);
            if (itm?.is_popular) popularItems.push(id);
          });
        });
      });
      const firstMenu = menusData[0];
      const idx = firstMenu.category_id.findIndex((c) => c.id === 'Popular');
      if (idx > -1) firstMenu.category_id[idx].items_id = popularItems;
      else
        firstMenu.category_id.unshift({
          id: 'Popular',
          items_id: popularItems,
        });
    }

    dispatch(menues(menusData));
    dispatch(
      allactiveMenues(menusData.filter((m) => !m.off_menu).map((m) => m.id))
    );
    navigate('/menu');
  };

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card
        sx={{
          width: CARD_WIDTH,
          height: CARD_HEIGHT,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <CardActionArea sx={{ flexGrow: 1 }}>
          <Box
            sx={{
              position: 'relative',
              height: IMAGE_HEIGHT,
              overflow: 'hidden',
            }}
          >
            <CardMedia
              component="img"
              image={store.image}
              alt="Restaurant"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                bgcolor: '#f5f5f5',
              }}
            />

            <Box
              sx={{
                position: 'absolute',
                top: 8,
                left: 8,
                bgcolor: 'white',
                borderRadius: '50px',
                px: 1,
                display: 'flex',
                alignItems: 'center',
                boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 700, mr: 0.5 }}>
                {store.rating.aggregate_rating || 0.0}
              </Typography>
              <StarPurple500SharpIcon
                sx={{ color: '#FFC529', fontSize: 16, mr: 0.5 }}
              />
              <Typography variant="caption" sx={{ fontWeight: 700 }}>
                ({store.rating.reviews >= 25 ? '25+' : store.rating.reviews})
              </Typography>
            </Box>
          </Box>
          <CardContent sx={{ pt: 1, pb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
              {displayName}
            </Typography>
            <Typography
              variant="body2"
              sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}
            >
              <LocationOnIcon sx={{ mr: 0.5, color: environment.mainColor }} />
              {store.address.displayName?.split(',').slice(0, 2).join(', ')}
            </Typography>
            <Typography
              variant="body2"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <AccessTimeFilledIcon
                sx={{ mr: 0.5, color: environment.mainColor }}
              />
              {t('10-15mins')}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
}
